import { Card, CardContent, Stack, SvgIcon, Typography } from '@mui/material';

import { ReactComponent as AuditReady } from 'assets/images/ic_audit_readiness.svg';

const NoAuditGatesCard = (): React.ReactElement => (
  <Card variant="outlined">
    <CardContent>
      <SvgIcon
        component={AuditReady}
        inheritViewBox
        className="view-icon"
        fontSize="inherit"
        htmlColor="#3D3C42"
      />
      <Stack
        direction="column"
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant="h6">No approval gates configured</Typography>
        <Typography component="span">
          Create approval gates to define the mandatory steps AI systems must
          pass through for approval.
        </Typography>
      </Stack>
    </CardContent>
  </Card>
);

export default NoAuditGatesCard;
